/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './DataServiceEntities.g';

export function necUploadImageQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function necUploadImageInput(base64Data: string, fileName: string): IDataServiceRequest {
    const query = necUploadImageQuery();

    return query.createDataServiceRequestForOperation(
        'NECUploadImage',
        true,
        DataServiceEntities.ImageResponseClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IImageResponse' },
        {
            imageData: {
                Base64Data: base64Data,
                FileName: fileName
            }
        }
    );
}

export function necUploadImageAsync(
    context: IContext,
    base64Data: string,
    fileName: string
): AsyncResult<DataServiceEntities.IImageResponse> {
    const request = necUploadImageInput(base64Data, fileName);
    return callActionOrExecute<DataServiceEntities.IImageResponse>(request, context.callerContext);
}

export function necGetProductTimeSlots(): DataServiceQuery {
    return new DataServiceQuery();
}

export function necGetProductTimeSlotsInput(itemId: string, catalogId: number): IDataServiceRequest {
    const query = necGetProductTimeSlots().resultSettings({ Paging: { Top: 100 } });

    return query.createDataServiceRequestForOperation(
        'NECGetProductTimeslots',
        true,
        DataServiceEntities.ProductTimeSlotsResponse,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ProductTimeSlotsResponse' },
        {
            catalogId,
            itemId
        }
    );
}

export function getTimeSlotsAsync(
    context: IContext,
    itemId: string,
    catalogId: number
): AsyncResult<DataServiceEntities.ProductTimeSlotsResponse[]> {
    const request = necGetProductTimeSlotsInput(itemId, catalogId);

    return callActionOrExecute<DataServiceEntities.ProductTimeSlotsResponse[]>(request, context.callerContext);
}
